export default {"src":"/_next/static/media/docEnVille50Details.e330f1d6.svg","height":206,"width":440,"blurWidth":0,"blurHeight":0};